<template>
  <header class="headerCart">
    <div class="headerCart__group">
      <div class="headerCart__logo">
        <router-link to="/">
          <img
            src="https://multiar.vteximg.com.br/arquivos/leveros-logo-tracking.png"
            alt="Logo"
            width="150px"
          />
        </router-link>
      </div>
      <div class="headerCart__secure">
        <svg
          version="1.1"
          id="Icons"
          width="35px"
          fill="#fff"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 32 32"
          style="enable-background: new 0 0 32 32"
          xml:space="preserve"
        >
          <path
            d="M26,12h-2v-2c0-4.4-3.6-8-8-8s-8,3.6-8,8v2H6c-0.6,0-1,0.4-1,1v16c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1V13
	C27,12.4,26.6,12,26,12z M17,22.8V24c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1.2c-1.2-0.4-2-1.5-2-2.8c0-1.7,1.3-3,3-3s3,1.3,3,3
	C19,21.3,18.2,22.4,17,22.8z M22,12H10v-2c0-3.3,2.7-6,6-6s6,2.7,6,6V12z"
          />
        </svg>

        <p>Ambiente e compra</p>
        <span>100% Seguro</span>
      </div>
    </div>
  </header>
</template>


<script>
export default {
  data() {
    return {
      token: null,
    }
  },

  async created() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));
        this.token = dados.token;

        if (
          window.location.pathname == window.location.pathname &&
          this.token == null
        ) {
          window.location.href = `/login?urlCallBack=${window.location.pathname}`;
        }
      } catch (e) {
        if (
          window.location.pathname == window.location.pathname &&
          this.token == null
        ) {
          window.location.href = `/login?urlCallBack=${window.location.pathname}`;
        }

        console.log(e);
      }
  },

}
</script>


<style lang="scss" scoped>
.headerCart {
  background: var(--standardGreen);

  &__group {
    max-width: 80%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;

    @media (min-width: 769px) {
      justify-content: space-between;
    }
  }

  &__secure {
    display: none;

    @media (min-width: 769px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: var(--customWhite);

      p,
      span {
        font-size: 0.85rem;
      }

      p {
        margin-top: 8px;
        letter-spacing: 0.5px;
      }
    }
  }
}
</style>